import { ChainId_Internal } from '../types';
export const rpcUrls = {
    [ChainId_Internal.ETHEREUM]: 'https://eth-rpc.zkevm.cronos.org',
    [ChainId_Internal.SEPOLIA]: 'https://ethereum-sepolia-rpc.publicnode.com',
    [ChainId_Internal.ZK_EVM]: 'https://mainnet.zkevm.cronos.org',
    [ChainId_Internal.ZK_EVM_TEST]: 'https://testnet.zkevm.cronos.org',
    [ChainId_Internal.CRONOS_EVM_MAINNET]: 'https://mainnet.cronoslabs.com/v1/ea0f1c40f912a166bf1224fedd07b442',
    [ChainId_Internal.CRONOS_EVM_TESTNET]: 'https://testnet.cronoslabs.com/v1/ea0f1c40f912a166bf1224fedd07b442',
};
export const chainNames = {
    [ChainId_Internal.ETHEREUM]: 'Ethereum',
    [ChainId_Internal.SEPOLIA]: 'Sepolia',
    [ChainId_Internal.ZK_EVM]: 'Cronos zkEVM',
    [ChainId_Internal.ZK_EVM_TEST]: 'Cronos zkEVM Testnet',
    [ChainId_Internal.CRONOS_EVM_MAINNET]: 'Cronos EVM',
    [ChainId_Internal.CRONOS_EVM_TESTNET]: 'Cronos EVM Testnet',
};
